import React from 'react';
import { Container, CTABlock, Paper } from 'library';

import UseCaseCardsBlock from '../../useCases/UseCaseCardsBlock/UseCaseCardsBlock';

import './UseCasesModule.scss';

const UseCasesModule = ({ title, text, showDivider = true }) => {
  return (
    <Paper className="UseCaseBlock" theme="medium" divider={showDivider}>
      <UseCaseCardsBlock title={title || 'You own your home. Now own your goals.'} text={text || ''} />
      <Container className="UseCaseBlockCta" align="center">
        <CTABlock
          text="Take our 5-minute quiz to see if we might be a good fit."
          title="Find out if Hometap can help you"
          buttonLabel="Is Hometap right for me?"
          buttonLink="/fit-quiz"
        />
      </Container>
    </Paper>
  );
};

export default UseCasesModule;
